var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircleOutlinedSlim = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 32.5c-8.837 0-16-7.163-16-16S7.163.5 16 .5s16 7.163 16 16-7.163 16-16 16m0-2c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14m6.207-20.61a1 1 0 1 1 1.586 1.22l-10 13a1 1 0 0 1-1.5.097l-4-4a1 1 0 1 1 1.414-1.414l3.195 3.195z"
})));
export default SvgCheckCircleOutlinedSlim;